var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dialog',{attrs:{"title":_vm.$t('report.removeReport.title'),"buttons":_vm.buttons,"close-enabled":!_vm.removing},on:{"close":_vm.cancel}},[_c('Paragraph',{attrs:{"text":_vm.message}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }